const extractPropertyOptions = (items) => {
	const propertyOptions = {
		height: [],
		width: [],
		depth: [],
		extraFields: {},
	};

	const addIfNotThere = (array, value, image, description) => {
		if (array.findIndex((option) => option.value === value + '') === -1) {
			array.push({
				value: value + '',
				description: description,
				image: image,
			});
		}
	};

	items.forEach((item) => {
		addIfNotThere(propertyOptions.height, item.height);
		addIfNotThere(propertyOptions.width, item.width);
		addIfNotThere(propertyOptions.depth, item.depth);
		const extraFields = item?.extraFields;
		const firstExtraFields = extraFields ? extraFields[0] : null;
		firstExtraFields?.forEach((extrafield) => {
			if (!propertyOptions.extraFields[extrafield.code]) {
				propertyOptions.extraFields[extrafield.code] = {
					name: extrafield.name,
					code: extrafield.code,
					description: extrafield.description,
					imageSelect: extrafield.imageSelect,
					options: [],
				};
			}
			addIfNotThere(
				propertyOptions.extraFields[extrafield.code].options,
				extrafield.value,
				extrafield.image,
				extrafield.description
			);
		});
	});
	return propertyOptions;
};

export default () => {
	const data = {
		properties: {
			extraFields: {
				uvegszin: '',
				Profilszin: '',
			},
		},
		propertyOptions: {},

		internalSelectedItem: 0,

		external: {
			configuratorItems: [],
			selectedItem: 0,
		},

		cache: {
			internalSelectedItemObj: null,
		},

		init() {
			this.$watch('external.configuratorItems', (_) => {
				this.propertyOptions = extractPropertyOptions(
					this.external.configuratorItems
				);
				console.log(this.propertyOptions);
				this.properties = Object.fromEntries(
					Object.entries(this.propertyOptions).map(
						([key, values]) => [
							key,
							values[0] === undefined ? '' : values[0].value,
						]
					)
				);
			});

			this.$watch('external.selectedItem', (changed) => {
				this.internalSelectedItem = changed;
				this.updateSelectedObj();
				this.updateProperties();
			});

			this.$watch('properties', (_) => {
				this.updateSelected();
			});

			if (this.onModalOpen) {
				this.onModalOpen = () => {
					this.updateSelected();
				};
			}
		},

		updateProperties() {
			const extraFieldsFirst = this.p().extraFields
				? this.p().extraFields[0]
				: null;
			this.properties = {
				height: this.p().height,
				width: this.p().width,
				depth: this.p().depth,
				extraFields: Object.fromEntries(
					extraFieldsFirst.map((field) => {
						return [field.code, field.value];
					})
				),
			};
		},

		updateSelected() {
			this.internalSelectedItem = this.external.configuratorItems.find(
				(item) => {
					return (
						item.width == this.properties.width &&
						item.height == this.properties.height &&
						item.depth == this.properties.depth &&
						Object.entries(this.properties.extraFields).reduce(
							(acc, kv) => {
								const extraFieldsFirst = item.extraFields
									? item.extraFields[0]
									: null;
								const relevantField = extraFieldsFirst.find(
									({ code }) => code === kv[0]
								);
								return acc && relevantField.value === kv[1];
							},
							true
						)
					);
				}
			)?.id;
			this.updateSelectedObj();
		},

		updateSelectedObj() {
			this.cache.internalSelectedItemObj =
				this.external.configuratorItems.find(
					(item) => item.id == this.internalSelectedItem
				);
		},

		isNotGiven(key) {
			return (
				!this.propertyOptions[key] ||
				(this.propertyOptions[key].length === 1 &&
					this.propertyOptions[key][0].value === '0')
			);
		},

		isInvalidConfig() {
			return this.internalSelectedItem === undefined;
		},

		getOptionLabel(array, value) {
			return array?.find((e) => e.value === value)?.label;
		},

		copyProperties(from, to) {
			Object.keys(from).forEach((prop) => (to[prop] = from[prop]));
		},

		apply() {
			// console.log('apply');
			// console.log(this.isInvalidConfig());
			// console.log(this.internalSelectedItem);
			if (!this.isInvalidConfig()) {
				this.open(false);
				this.external.selectedItem = this.internalSelectedItem;
			}
		},

		cancel() {
			this.open(false);
		},

		p() {
			return this.cache.internalSelectedItemObj;
		},

		po() {
			console.log(this.propertyOptions);
			return this.propertyOptions;
		},

		capitalize(str) {
			if (typeof str === 'string') {
				return str.charAt(0).toUpperCase() + str.slice(1);
			}
			return str;
		},
	};

	return data;
};
